import { createSelector } from 'reselect';

import { getIssueState } from '../reducers';

const getIssueLayoutMap = createSelector(getIssueState, state => state.layout);

export const selectIssueLayoutByCidDateKey = createSelector(
    [getIssueLayoutMap, (_state: unknown, cidDateKey: string) => cidDateKey],
    (map, cidDateKey) => map[cidDateKey],
);
